<div>
  <netz-page-heading>{{ facility.facilityDetails.name }} ({{ facility.facilityId }})</netz-page-heading>

  <cca-summary [data]="summaryData()" />
</div>
